import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { existingStreamInput } from '../../../../interfaces/streamsmodel';
import { FeedstockService } from '../../../../services/feedstockservice';
import { IdName } from '../../../../interfaces/pricematrixmodel';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroupDirective, FormsModule, NgForm } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { ErrorStateMatcher } from '@angular/material/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

export class OnSubmitErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-add-existing-stream',
  imports: [
      CommonModule,
      FormsModule,
      MatCardModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatButtonModule,
      MatIconModule,
      MatExpansionModule,
      MatDialogModule,
      DragDropModule
  ],
  templateUrl: './add-existing-stream.component.html',
  styleUrls: ['./add-existing-stream.component.scss']
})
export class AddExistingStreamComponent {
  @ViewChild('streamForm') streamForm!: NgForm;
  genId: string = "";
  marketId: string = "-1";
  existingStreams: IdName[] = [];
  filteredExistingStreams: IdName[] = [];
  selectedStreamId: number | null = null;

  constructor(public dialogRef: MatDialogRef<AddExistingStreamComponent>,private fsService: FeedstockService,
    @Inject(MAT_DIALOG_DATA) public data: existingStreamInput) {
      this.genId = `${data.generatorId}`;
      this.marketId = `${data.marketId}`;
      this.loadDropdownData();
      console.log("incoming existing stream data: ", data);
  }

  loadDropdownData() {
    this.fsService.getExistingStreamList(parseInt(this.genId)).subscribe({
      next: (response) => {
        console.log("Stream dropdown data: ", response);
        this.existingStreams = response.map(stream => ({ id: stream.streamId ?? 0, name: stream.name ?? '' }));
        this.filteredExistingStreams = response.map(stream => ({ id: stream.streamId ?? 0, name: stream.name ?? '' }));
      }
    });
  }
  
  closeModal(){
    this.dialogRef.close(false);
  }

  saveStreamData(){
    const control = this.streamForm.form.controls['streamSelect'];
    
    // 2. Mark as touched AND dirty to trigger validation styles
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity();
    if(this.selectedStreamId){
      var genId = this.genId ? parseInt(this.genId) : 0;
      var marketId = this.marketId ? parseInt(this.marketId) : null;
      var streamId = this.selectedStreamId; 
      this.fsService.saveExistingStream({ generatorId: genId, streamId: streamId }).subscribe({
        next: (response) => {
          console.log("Save response: ", response);
        }
      });
      this.dialogRef.close(true);
    }
  }

  filterStreams(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredExistingStreams = [...this.existingStreams];
    } else {
      this.filteredExistingStreams = this.existingStreams.filter(
        stream => stream.name.toLowerCase().includes(searchTerm)
      );
    }
  }
}